<fin-sub-header
  [hasBasket]="false"
  [isBasketDisabled]="true"
  [hasActiveBasketState]="false"
  [hasBasketActionInMobileOnly]="false"
  [backgroundColorClass]="'nordic-blue-900-bg'"
  [noHeader]="isInsideApp"
>
  <div class="flex flex--space-between flex--middle">
    <fcom-button
      data-testid="check-in-subheader-exit-check-in"
      class="back-button"
      *ngIf="!isInsideApp"
      [theme]="ButtonTheme.DARK_TERTIARY_GHOST"
      [attr.title]="'actions.back' | finLocalization"
      [icon]="{
        name: SvgLibraryIcon.ARROW_LEFT,

        position: IconPosition.LEFT,
      }"
      [text]="exitCheckInTextKey$ | async | finLocalization"
      (clickBtn)="exitCheckIn.emit()"
    >
    </fcom-button>
    <div class="flex flex--center" [ngClass]="{ 'flex-1': isInsideApp }">
      <div
        class="flex"
        [ngClass]="{ 'flex--space-between flex--middle flex-1': isInsideApp, 'flex--center': !isInsideApp }"
      >
        <div class="" [ngClass]="{ 'border-left border-right-dashed': !isInsideApp }">
          <span class="flex flex--column pr-xsmall-x font-body-1">
            <ng-container *ngIf="(isLaptopUp$ | async) === true; else flightIndicationMobile">
              <span>
                <span class="bold-type">{{ locations[bound.departure.locationCode]?.cityName }}</span
                >{{ '(' + bound.departure.locationCode + ')' + ' - ' }}
                <span class="bold-type"> {{ locations[bound.arrival.locationCode]?.cityName }}</span>
                {{ '(' + bound.arrival.locationCode + ')' }}
              </span>
              <span
                >{{ bound.departure.dateTime | finDateFormat: 'E d MMM' }} /
                <fcom-icon class="icon-button-small" [name]="SvgLibraryIcon.DEPARTURE"></fcom-icon>
                {{ bound.departure.dateTime | finTime }}</span
              >
            </ng-container>
          </span>
        </div>

        <ng-template #flightIndicationMobile>
          @if (isInsideApp) {
            <span class="bold-type">
              {{ locations[bound.departure.locationCode]?.cityName }}–{{
                locations[bound.arrival.locationCode]?.cityName
              }}
            </span>
          } @else {
            <span>
              <span class="bold-type">{{ bound.departure.locationCode }}</span>
              <span class="flex--nogrow ps-xxsmall-x">
                <fcom-icon class="icon-small" [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL"></fcom-icon>
              </span>
              <span class="bold-type">{{ bound.arrival.locationCode }}</span>
            </span>
          }
        </ng-template>

        <fcom-button
          *ngIf="(isMobile$ | async) === false"
          class="ms-xsmall-l"
          data-testid="check-in-subheader-view-details-desktop"
          [theme]="ButtonTheme.DARK_TERTIARY_GHOST"
          [icon]="{
            name: SvgLibraryIcon.INFO_BLOCK,

            position: IconPosition.LEFT,
          }"
          [text]="
            (isMobile$ | async) === false ? ('MMB.checkIn.funnel.navigationBar.viewDetails' | finLocalization) : ''
          "
          (clickBtn)="viewFlightDetails.emit()"
        >
        </fcom-button>
        <fcom-icon-button
          *ngIf="(isMobile$ | async) === true"
          class="ms-xsmall-l"
          data-testid="check-in-subheader-view-details-mobile"
          [theme]="IconButtonTheme.DARK_TERTIARY_GHOST"
          [aria]="{ label: 'MMB.checkIn.funnel.navigationBar.viewDetails' | finLocalization }"
          [icon]="{
            name: SvgLibraryIcon.INFO_BLOCK,
          }"
          (clickBtn)="viewFlightDetails.emit()"
        >
        </fcom-icon-button>
      </div>
    </div>
  </div>
</fin-sub-header>
